import DownloadIcon from "@mui/icons-material/Download";
import style from "./style.module.scss";

const Download = ({ files = [] }) => (
  <div className={style.block}>
    {files?.length > 0 &&
      files.map((file, i) => (
        <a
          key={file.title}
          download
          href={file.url ?? undefined}
          className={style.file}
        >
          <DownloadIcon />
          <div className={style.fileName}>{file.title}</div>
        </a>
      ))}
  </div>
);

export default Download;
